import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import SectionWithHeader from 'layout/SectionWithHeader'
import styles from './index.css'

@withRouter
export default class FormWithActions extends React.Component {
  
  static propTypes = {
    title : PropTypes.string,
    headerChildren: PropTypes.any,
    actions: PropTypes.any
  }

  static defaultProps = {
    title: '',
    headerChildren: null,
    actions: null,
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <SectionWithHeader title={this.props.title} headerChildren={this.props.headerChildren}>
        {this.props.children}
        <div className={styles.Actions}>
          { this.props.actions }
        </div>
      </SectionWithHeader>
    )
  }

}



// WEBPACK FOOTER //
// ./src/layout/FormWithActions/index.jsx